<section *ngIf="viewModel$ | async as vm" class="is-flex text-12">
  <div *ngFor="let measureCard of vm.measureCards" class="legend-item is-flex gap-8 is-align-center">
    <div class="legend-chip" [style.backgroundColor]="'var(' + measureCard.color + ')'"></div>
    <app-text class="text-grey-70 is-family-medium">{{ measureCard.label }}</app-text>
  </div>
</section>